<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    color="transparent"
    flat
    height="75"
  >
    <v-btn
      class="mr-3"
      elevation="1"
      fab
      small
      @click="setDrawer(!drawer)"
    >
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>

    <v-toolbar-title
      class="hidden-sm-and-down font-weight-light"
      v-text="$route.name"
    />

    <v-spacer />
    <v-btn
      class="ml-2"
      min-width="0"
      text
      @click="CanSwitchStore() ? show_store_lookup = true : null"
    >
      <v-icon>mdi-store</v-icon>
      <h3>
        {{ store_name }}
      </h3>
    </v-btn>
    <v-btn
      v-if="loading_store"
      text
      loading
    />
    <v-menu
      open-on-hover
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <!-- <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-badge
            color="red"
            overlap
            bordered
          >
            <template v-slot:badge>
              <span>1</span>
            </template>

            <v-icon>mdi-bell</v-icon>
          </v-badge>
        </v-btn>
      </template> -->

      <v-list
        :tile="false"
        nav
      >
        <div>
          <app-bar-item
            v-for="(n, i) in notifications"
            :key="`item-${i}`"
          >
            <v-list-item-title v-text="n" />
          </app-bar-item>
        </div>
      </v-list>
    </v-menu>

    <v-menu
      open-on-hover
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item-group>
          <v-list-item>
            <app-bar-item>
              <v-list-item-content>
                <v-list-item-title>
                  <span>Welcome </span>
                  <span
                    class="primary--text"
                    style="font-weight:400;"
                  >
                    {{ user }}!
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </app-bar-item>
          </v-list-item>
          <v-divider />
          <v-list-item
            v-if="is_admin"
            @click="ShowAdvanced()"
          >
            <app-bar-item>
              <v-list-item-content>
                <v-list-item-title v-text="'Advanced'" />
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon v-text="'mdi-shield-account-outline'" />
              </v-list-item-icon>
            </app-bar-item>
          </v-list-item>
          <v-divider />
          <v-list-item @click="Logout">
            <app-bar-item>
              <v-list-item-content>
                <v-list-item-title v-text="'Logout'" />
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon v-text="'mdi-logout-variant'" />
              </v-list-item-icon>
            </app-bar-item>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>

    <!-- Switch Store dialog -->
    <v-dialog
      v-model="show_store_lookup"
      width="400"
    >
      <v-card>
        <v-card-title class="text-left">
          <h2 class="primary--text">
            Switch Store
          </h2>
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="select_store"
            :loading="loading_store_lookup"
            :items="store_lookup"
            item-text="store_name"
            item-value="uid"
            flat
            hide-no-data
            hide-details
            dense
            min-width="0"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="SwitchStore()"
          >
            Apply
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="show_store_lookup = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Switch Store dialog -->

    <!-- Advanced dialog -->
    <v-dialog
      v-model="show_advanced"
      fullscreen
      :retain-focus="false"
      transition="dialog-bottom-transition"
      dense
      fixed
    >
      <v-card>
        <v-toolbar
          flat
          color="blue-grey"
          dark
        >
          <v-btn icon>
            <v-icon>mdi-shield-account-outline</v-icon>
          </v-btn>
          <v-toolbar-title>Advanced Settings</v-toolbar-title>
          <v-spacer />
          <v-btn
            text
            dark
            @click="show_advanced = false"
          >
            <v-icon icon>
              mdi-close
            </v-icon>
            &nbsp;Close
          </v-btn>
        </v-toolbar>
        <v-card-text style="padding-top: 12px;padding-bottom: 0;">
          <v-tabs vertical>
            <v-tab
              v-for="(item, i) in items"
              :key="i"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon" />
              </v-list-item-icon>
              <v-list-item-content class="text-left">
                <v-list-item-title v-text="item.text" />
              </v-list-item-content>
            </v-tab>
            <v-tab-item>
              <v-card>
                <v-card-text style="padding-top: 10px;padding-bottom: 0;">
                  <v-col>
                    <v-data-table
                      :headers="headers_permissions"
                      :items="permissions"
                      :loading="loading_permissions"
                      :disable-sort="true"
                      :loading-text="loading_text"
                      :items-per-page="100"
                      group-by="seq"
                      fixed-header
                      height="calc(100vh - 120px)"
                      hide-default-header
                      hide-default-footer
                      style="padding-top:10px"
                      class="elevation-4 text-no-wrap dense-2"
                    >
                      <template v-slot:header="{ props }">
                        <thead class="v-data-table-header">
                          <tr>
                            <th
                              v-for="(header, index) in props.headers"
                              :key="header.text + index"
                              role="columnheader"
                              scope="col"
                              :class="{'text-start title': true, hidden: index==1}"
                              :colspan="index==0?2:1"
                              :aria-label="header.text"
                            >
                              <span>{{ header.text }}</span>
                              <a
                                v-if="index>3 && !loading_permissions"
                                style="color: inherit;"
                                @click="DeleteRole(header.value)"
                              >
                                &nbsp;
                                <v-icon
                                  small
                                  color="error"
                                >
                                  mdi mdi-close
                                </v-icon>
                              </a>
                              <v-btn
                                v-if="index == props.headers.length-1 && !loading_permissions"
                                small
                                color="blue-grey"
                                style="float:right;margin-right:10px"
                                @click="ShowNewRole()"
                              >
                                New
                              </v-btn>
                              <v-btn
                                v-if="index == props.headers.length-1 && !loading_permissions"
                                small
                                color="blue-grey"
                                style="float:right;margin-right:10px"
                                @click="UpdatePermissions()"
                              >
                                Save
                              </v-btn>
                            </th>
                          </tr>
                        </thead>
                      </template>
                      <template v-slot:[`group.header`]="{ group, items }">
                        <td
                          :colspan="headers_permissions.length"
                          style="background-color: #adc0ca"
                        >
                          <span>{{ items.find(x => x.seq == group).feature }}</span>
                        </td>
                      </template>
                      <template v-slot:[`item`]="{ item }">
                        <tr class="dark-row">
                          <template
                            v-for="(v,k) in item"
                          >
                            <td
                              v-if="k == 'feature'"
                              :key="v+k"
                            />
                            <td
                              v-if="k == 'access'"
                              :key="v+k"
                            >
                              {{ v }}
                            </td>
                            <td
                              v-if="typeof item[k] == 'boolean'"
                              :key="v+k"
                            >
                              <v-checkbox
                                v-model="item[k]"
                                color="success"
                                style="margin-top:0"
                                hide-details
                              />
                            </td>
                          </template>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card style="min-height:532px">
                <v-card-text>
                  <p>
                    System logs...
                  </p>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card style="min-height:532px">
                <v-card-text>
                  <p>
                    System Info...
                  </p>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End advanced dialog -->

    <!-- New Role dialog -->
    <v-dialog
      v-model="show_new_role"
      width="30%"
      max-width="40%"
    >
      <v-card>
        <v-card-title class="text-left">
          <h2 class="primary--text">
            New Role
          </h2>
        </v-card-title>
        <v-card-text>
          <v-col
            cols="12"
            sm="10"
          >
            <v-form
              ref="new_role_form"
              lazy-validation
            >
              <v-text-field
                ref="name"
                v-model="name"
                label="Name"
                :rules="[
                  v => !!v || 'This is required',
                  v => !!v && v.length <= 10 || 'Max input of 10 characters only.'
                ]"
                @keydown.enter="$refs.description.focus()"
              />
              <v-text-field
                ref="description"
                v-model="description"
                label="Description"
                :rules="[
                  v => !!v || 'This is required',
                  v => !!v && v.length <= 20 || 'Max input of 20 characters only.'
                ]"
              />
            </v-form>
          </v-col>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            :disabled="in_process"
            @click="SaveNewRole()"
          >
            Save
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="in_process"
            @click="show_new_role = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End New Role dialog -->
    <confirm ref="confirm" />
  </v-app-bar>
</template>

<script>
  import {
    GetStoreInfo,
  } from '@/graphql/Dashboard.gql'
  import { Logout } from '@/graphql/Auth.gql'
  import { onLogout } from '@/vue-apollo'
  import {
    GetProfitCenters,
    GetStoreLookup,
    SwitchStore,
  } from '@/graphql/Store.gql'
  import {
    GetPermissions,
    UpdatePermissions,
    CreateNewRole,
    DeleteRole,
  } from '@/graphql/User.gql'
  // Components
  // rebuild
  import { VHover, VListItem } from 'vuetify/lib'

  // Utilities
  import { mapState, mapMutations } from 'vuex'

  export default {
    name: 'DashboardCoreAppBar',

    components: {
      Confirm: () => import('@/views/dashboard/component/Confirm'),
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      selectedItem: 0,
      items: [
        { text: 'Roles & Permissions', icon: 'mdi-account-group' },
        // { text: 'Activity Logs', icon: 'mdi-playlist-edit' },
        // { text: 'System', icon: 'mdi-cog-outline' },
      ],
      user: '',
      store_number: null,
      store_name: "McDonald's",
      notifications: [
        'Escheduling Version 1.0',
      ],
      loading_store: false,
      skip_store: true,
      error: false,
      select_store: null,
      search: null,
      select: null,
      store_lookup: [],
      permissions: [],
      headers_permissions: [
        { text: 'Features', value: 'feature' },
        { text: 'Access', value: 'access' },
        { text: 'Admin', value: 'admin' },
        { text: 'Escheduler', value: 'esched' },
      ],
      loading_permissions: false,
      loading: false,
      loading_store_lookup: true,
      skip_store_lookup: true,
      skip_permissions: true,
      store_lookup_hash: '',
      permissions_hash: '',
      show_store_lookup: false,
      show_advanced: false,
      loading_text: 'Please wait while loading data...',
      show_new_role: false,
      name: '',
      description: '',
      loading_profit_centers: false,
      skip_profit_centers: true,
    }),

    computed: {
      ...mapState(['in_process', 'drawer', 'is_admin', 'access', 'roles']),
    },
    mounted () {
      this.GetStoreInfo()
    },
    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),
      DeleteRole (role) {
        if (!this.is_admin) { return }
        this.$refs.confirm.open('Please Confirm!', 'You are going to delete this role!', { color: 'red' })
          .then((confirm) => {
            if (confirm) {
              this.$store.commit('Notify', { snack_text: 'Please wait...', snack_color: 'blue-grey' })
              this.$apollo.mutate({
                mutation: DeleteRole,
                variables: {
                  name: role,
                },
              }).then((res) => {
                if (res.data.DeleteRole.status === 'Ok') {
                  this.$store.commit('CloseAlert', '')
                  this.GetPermissions()
                } else {
                  this.$store.commit('ShowError', res.data.DeleteRole.status)
                }
              }).catch(error => {
                this.CheckError(error)
              })
            }
          })
      },
      ShowNewRole () {
        this.name = ''
        this.description = ''
        this.show_new_role = true
        setTimeout(() => {
          this.$refs.name.focus()
        }, 0)
      },
      SaveNewRole () {
        if (!this.is_admin) { return }
        if (!this.$refs.new_role_form.validate()) {
          this.$store.commit('ShowError', 'Please check your input!')
          return
        }
        this.$store.commit('Notify', { snack_color: 'blue-grey' })
        this.$apollo.mutate({
          mutation: CreateNewRole,
          variables: {
            name: this.name,
            description: this.description,
          },
        }).then((res) => {
          if (res.data.CreateNewRole.status === 'Ok') {
            this.$store.commit('CloseAlert', '')
            this.show_new_role = false
            this.$refs.new_role_form.resetValidation()
            this.GetPermissions()
          } else {
            this.$store.commit('ShowError', res.data.CreateNewRole.status)
          }
        }).catch(error => {
          this.CheckError(error)
        })
      },
      ShowAdvanced () {
        if (!this.is_admin) { return }
        this.GetPermissions()
      },
      GetProfitCenters () {
        this.loading_profit_centers = true
        this.skip_profit_centers = false
        this.$apollo.queries.GetProfitCenters.refetch()
      },
      GetPermissions () {
        this.permissions = []
        this.show_advanced = true
        this.loading_permissions = true
        this.skip_permissions = false
        this.$apollo.queries.GetPermissions.refetch()
      },
      CanSwitchStore () {
        const options = [this.roles.stores_switch, this.roles.stores_switch_profit_center, this.roles.stores_switch_patch]
        return options.some(el => this.access.includes(el))
      },
      SwitchStore () {
        if (!this.CanSwitchStore()) { return }
        if (!this.select_store) {
          this.$store.commit('ShowError', 'Please select store!')
          return
        }
        this.$store.commit('Notify', 'Please wait...')
        this.$apollo.mutate({
          mutation: SwitchStore,
          variables: {
            hash: this.store_lookup_hash,
            uid: this.select_store,
          },
        }).then((res) => {
          if (res.data.SwitchStore.status === 'Ok') {
            this.$router.go()
          } else if (res.data.SwitchStore.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.SwitchStore.status)
          }
        }).catch(error => {
          this.CheckError(error)
        })
      },
      UpdatePermissions () {
        if (!this.is_admin) { return }
        this.$store.commit('Notify', { snack_color: 'blue-grey' })
        this.$apollo.mutate({
          mutation: UpdatePermissions,
          variables: {
            hash: this.permissions_hash,
            permissions: JSON.stringify(this.permissions),
          },
        }).then((res) => {
          if (res.data.UpdatePermissions.status === 'Ok') {
            this.$store.commit('CloseAlert', '')
          } else if (res.data.UpdatePermissions.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.UpdatePermissions.status)
          }
        }).catch(error => {
          this.CheckError(error)
        })
      },
      GetStoreInfo () {
        this.loading_store = true
        this.skip_store = false
        this.$apollo.queries.GetStoreInfo.refetch()
      },
      GetStoreLookup () {
        this.loading_store_lookup = true
        this.store_lookup = []
        this.skip_store_lookup = false
        this.$apollo.queries.GetStoreLookup.refetch()
      },
      Logout () {
        this.$store.commit('Notify', 'Please wait...')
        this.error = false
        this.$apollo.mutate({
          mutation: Logout,
          variables: {
          },
        }).then((res) => {
          this.loading_logout = false
          if (res.data.Logout) {
            if (res.data.Logout.status === 'TOKEN_REVOKED') {
              onLogout(this.$apollo.provider.defaultClient)
              window.location.href = '/login'
            } else {
              this.$store.commit('ShowError', res.data.Logout.status)
            }
          }
        }).catch(error => {
          this.onError = error
          window.location.href = '/login'
        })
      },
      ReRoute () {
        if (this.access.includes(this.roles.dashboard)) {
          this.$router.push('/')
        } else { this.$router.push('/my-account') }
      },
    },
    apollo: {
      GetProfitCenters: {
        error (error) {
          this.loading_profit_centers = false
          this.CheckError(error)
        },
        query: GetProfitCenters,
        variables () {
          return {
          }
        },
        skip () {
          return this.skip_profit_centers
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetProfitCenters.status === 'Ok') {
              this.$store.commit('set_profit_centers', data.GetProfitCenters.data)
              this.$store.commit('set_profit_centers_hash', data.GetProfitCenters.hash)
              this.$store.commit('set_profit_center_default', data.GetProfitCenters.default)
            } else if (data.GetProfitCenters.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            } else {
              this.$store.commit('ShowError', data.GetProfitCenters.status)
            }
            this.loading_profit_centers = false
            this.skip_profit_centers = true
          }
        },
      },
      GetStoreInfo: {
        error (error) {
          this.loading_store = false
          this.CheckError(error)
        },
        query: GetStoreInfo,
        variables () {
          return {
          }
        },
        skip () {
          return this.skip_store
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetStoreInfo.status === 'Ok') {
              this.user = data.GetStoreInfo.user
              this.store_number = data.GetStoreInfo.store_number
              this.store_name = data.GetStoreInfo.store_name
              this.$store.commit('set_admin', data.GetStoreInfo.is_admin)
              this.$store.commit('set_access', JSON.parse(data.GetStoreInfo.access))
              this.loading_store = false
              this.skip_store = true
              // check routes
              if (this.$route.name === 'Users' && !this.access.includes(this.roles.users)) { this.ReRoute() }
              if (this.$route.name === 'Stores' && !this.access.includes(this.roles.stores)) { this.ReRoute() }
              if (this.$route.name === 'Scheduler' && !this.access.includes(this.roles.scheduler)) { this.ReRoute() }
              if (this.$route.name === 'Settings' && !this.access.includes(this.roles.settings)) { this.ReRoute() }
              if (this.$route.name === 'Manager Forecast' && !this.access.includes(this.roles.mforecast)) { this.ReRoute() }
              if (this.$route.name === 'Dashboard' && !this.access.includes(this.roles.dashboard)) { this.ReRoute() }
              if (this.$route.name === 'Crew List' && !this.access.includes(this.roles.crewlist)) { this.ReRoute() }
              if (this.$route.name === 'Reports' && !this.access.includes(this.roles.reports)) { this.ReRoute() }
              if (this.$route.name === 'Biometrics' && !this.access.includes(this.roles.biometrics)) { this.ReRoute() }
              //
              if (this.access.includes(this.roles.stores_switch) || this.access.includes(this.roles.stores_switch_profit_center)) { this.GetProfitCenters() }
              if (this.CanSwitchStore()) { this.GetStoreLookup() }
            } else if (data.GetStoreInfo.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            }
          }
        },
      },
      GetStoreLookup: {
        error (error) {
          this.loading_store_lookup = false
          this.CheckError(error)
        },
        query: GetStoreLookup,
        variables () {
          return {
          }
        },
        skip () {
          return this.skip_store_lookup
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetStoreLookup) {
              if (data.GetStoreLookup.status === 'Ok') {
                this.store_lookup = data.GetStoreLookup.data
                this.store_lookup_hash = data.GetStoreLookup.hash
                this.loading_store_lookup = false
                this.skip_store_lookup = true
                if (!this.select_store) {
                  for (const index in this.store_lookup) {
                    if (this.store_number === this.store_lookup[index].store_number) {
                      this.select_store = this.store_lookup[index].uid
                    }
                    this.store_lookup[index].store_name = String(this.store_lookup[index].store_number).padStart(4, '0') + ' - McDonald\'s ' + this.store_lookup[index].store_name
                  }
                }
              } else {
                this.$store.commit('ShowError', data.GetStoreLookup.status)
              }
            }
          }
        },
      },
      GetPermissions: {
        error (error) {
          this.loading_permissions = false
          this.CheckError(error)
        },
        query: GetPermissions,
        variables () {
          return {
          }
        },
        skip () {
          return this.skip_permissions
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetPermissions) {
              this.loading_permissions = false
              if (data.GetPermissions.status === 'Ok') {
                this.permissions = JSON.parse(data.GetPermissions.permissions)
                this.headers_permissions = JSON.parse(data.GetPermissions.headers)
                this.permissions_hash = data.GetPermissions.hash
              } else if (data.GetPermissions.status === '0') {
                this.CheckError({ message: 'Session expired!' })
              } else {
                this.$store.commit('ShowError', data.GetPermissions.status)
              }
            }
          }
        },
      },
    },
  }
</script>
